import {
  ROUTE_LOCALE_COMPANY,
  ROUTE_LOCALE_COMPANY_WITH_EVENTS,
} from '@/constants/routes';

/**
 * Route action types which are 'enabled' to handle locale as a route param.
 *
 * e.g. /:locale/stocks/...
 */
const LOCALE_ROUTE_TYPES = [
  ROUTE_LOCALE_COMPANY,
  ROUTE_LOCALE_COMPANY_WITH_EVENTS,
] as const;
type LocaleRouteType = (typeof LOCALE_ROUTE_TYPES)[number];

/**
 * Determine whether a redux action type is one that supports locale in the url params.
 */
export const isLocaleRouteType = (
  actionType: string | LocaleRouteType
): actionType is LocaleRouteType => {
  return LOCALE_ROUTE_TYPES.includes(actionType as LocaleRouteType);
};

/**
 * Available route locale language translations.
 *
 * Note: `en` is valid as a language, but not in routing / url values. These use the 'default' non-locale routes instead.
 */
export const SUPPORTED_LOCALES = ['es', 'de'] as const;
type RouteLocale = (typeof SUPPORTED_LOCALES)[number];

export type Locale = RouteLocale | 'en';

export const isSupportedLocale = (
  localeValue: string | RouteLocale
): localeValue is RouteLocale => {
  return SUPPORTED_LOCALES.includes(localeValue as RouteLocale);
};

export const SUPPORTED_NAMESPACES = [
  'web',
  'statementGlossary',
  'page.companyReport',
  'page.companyReport.dividend',
] as const;
